<template>
  <div class="infinite-list list-con" 
       v-infinite-scroll="load" 
       :infinite-scroll-disabled="!isMore || isLoading"
       :infinite-scroll-distance="50"
       :infinite-scroll-immediate="false">
    <div class="item" v-for="(item, idx) in list" :key="`item-${idx}-${item.id || item.paper_id}`" @click="toDetail(item)" :class="{ 'shared-item': item.isShared }">
      <div class="item-title">
        <img v-if="activeName === 'paper'" class="icon-pdf" src="https://bookor-application.oss-cn-beijing.aliyuncs.com/Word-Local-hover.png"/>
        <i v-else-if="activeName === 'mindmap'" class="el-icon-share icon-mindmap"></i>
        <img v-else-if="activeName === 'article' && !item.isShared" class="icon-pdf" src="../../assets/img/article.png"/>
        <img v-else-if="activeName === 'article' && item.isShared" class="icon-pdf wechat-icon" src="https://cdn-icons-png.flaticon.com/512/220/220236.png"/>
        <img v-else-if="activeName === 'note'" class="icon-pdf" src="../../assets/img/note.png"/>
        <img v-else-if="activeName === 'comment'" class="icon-pdf" src="../../assets/img/article_comment.png"/>
        <img v-else-if="activeName === 'timeline'" class="icon-pdf" src="../../assets/img/note.png"/>
        <img v-else class="icon-pdf" src="../../assets/img/pdf.png" />
        <span class="title-text">{{ item.title }}</span>
        <span v-if="item.isShared" class="share-badge">好友分享</span>
      </div>

      <div class="right-func">
        <!-- 总结脑图按钮 -->
        <span v-if="activeName !== 'draft' && activeName !== 'mindmap'">
          <el-tooltip v-if="item?.loading" effect="dark" content="总结中" placement="top">
            <i class="el-icon-loading"></i>
          </el-tooltip>
          <el-tooltip v-else effect="dark" content="总结脑图" placement="top">
            <img class="mind-btn" src="https://bookor-formal.oss-cn-beijing.aliyuncs.com/mind.png" @click.stop="createdMind(item, idx)"/>
          </el-tooltip>
        </span>
        <!-- 脑图tab的脑图图标 -->
        <el-tooltip v-if="activeName === 'mindmap'" effect="dark" content="查看脑图" placement="top">
          <img class="mind-btn" src="https://bookor-formal.oss-cn-beijing.aliyuncs.com/mind.png" @click.stop="toDetail(item)"/>
        </el-tooltip>

        
        <el-popconfirm
          title="确认删除文档吗"
          @confirm="deleteDoc(item, idx)"
        >
          <i slot="reference" class="el-icon-delete" @click.stop></i>
        </el-popconfirm>
      </div>
    </div>
    <p v-if="!list.length" class="empty">暂无内容</p>

  </div>
</template>
<script lang="ts">
import request from '@/http/request';
import axios from '@/http';
import { searchEmu } from './util';
import { EventBus } from '@/main.js';

const typeConfig = {
  [searchEmu.PAPER]: 3,
  [searchEmu.ARTICLE]: 2,
    [searchEmu.THESIS]: 4,
  [searchEmu.BOOK_COMMENT]: 5,
  [searchEmu.NOTE]: 6,
  [searchEmu.TIMELINE]: 7
}

export default {
  data () {
    return {
      isMore: true,
      page: 1,
      size: 20,
      list: [],
      downloadVisible: false,
      isLoading: false // 添加加载状态锁，防止重复请求
    }
  },
  components: {},
  props: ['activeName'],
  watch: {
    activeName (val) {
      this.page = 1
      this.list = []
      this.isMore = true
      this.isLoading = false
      this.getList()
    }
  },
  mounted() {
    // 监听文章保存成功事件
    EventBus.$on('refreshFileFileList', this.getList);
    this.getList();
  },
  beforeDestroy() {
    // 在组件销毁前移除事件监听
    EventBus.$off('refreshFileFileList', this.getList);
  },
  methods: {
    handleShareClose() {
      this.downloadVisible = false
    },
    // 删除文档或论文
    deletePaper (item, idx) {
      const params = {
        paper_id: item.id || item.paper_id
      }
      request('/api/Paper/deletePaper', params).then((res) => {
        this.list.splice(idx, 1)
        this.$message({
          message: '删除成功',
          type: 'success',
          duration: 1000
        })
        EventBus.$emit('refreshFileFileList')
      }).catch((result) => {
        this.$message({
          message: (result && result.message) || '删除失败',
          type: 'error',
          duration: 1000
        })
      })
    },
    createdMind (item, idx) {
      // 检查是否已经保存过脑图（从localStorage或当前状态）
      const savedMindId = this.getSavedMindId(item, idx)
      if (savedMindId) {
        window.open(`#/mind/${savedMindId}`, '_blank')
        return
      }
      
      // 如果已经生成过脑图但没有保存，保存并跳转
      if (this.list[idx].mind) {
        const mindMapData = this.convertToMindMapFormat(this.list[idx].mind)
        this.saveMindToListAndNavigate(item, mindMapData, idx)
        return
      }
      
      let count = 0
      const type = typeConfig[this.activeName]
      let id = item.paper_id
      if ([searchEmu.ARTICLE, searchEmu.BOOK_COMMENT, searchEmu.NOTE].includes(this.activeName)) {
        id = item.id
      }
      
      // 验证文档ID是否有效
      if (!id) {
        this.$message.error('文档ID无效，无法生成脑图')
        return
      }
      
      // 验证文档类型是否有效
      if (!type || typeof type !== 'number') {
        this.$message.error('文档类型无效，无法生成脑图')
        return
      }
      
      const poll = () => {
        count += 1
        
        request('/api/Mindmap/getMindMapByInfo', {
          id,
          type
        }).then((result) => {
          if (Array.isArray(result)) {
            this.list[idx].loading = true
            this.$forceUpdate()
            
            if (count > 20) {
              this.list[idx].loading = false
              this.$forceUpdate()
              this.$message.error('脑图生成失败：超时（已等待约2分钟）')
              return
            }
            
            // 前10次每3秒轮询一次，之后每5秒轮询一次
            const interval = count <= 10 ? 3000 : 5000
            setTimeout(() => {
              poll()
            }, interval)
          } else {
            // 检查数据结构是否有效
            if (!result || typeof result !== 'object') {
              this.list[idx].loading = false
              this.$forceUpdate()
              this.$message.error('脑图生成失败：数据格式错误')
              return
            }
            
            if (!result.content) {
              this.list[idx].loading = false
              this.$forceUpdate()
              this.$message.error('脑图生成失败：缺少内容')
              return
            }
            
            this.list[idx].loading = false
            this.list[idx].mind = result
            this.$forceUpdate()
            
            // 转换数据格式用于保存
            const mindMapData = this.convertToMindMapFormat(result)
            
            // 生成脑图后，保存到脑图列表并跳转到编辑页面
            this.saveMindToListAndNavigate(item, mindMapData, idx)
          }
        }).catch((error) => {
          console.error('API调用失败:', error)
          this.list[idx].loading = false
          this.$forceUpdate()
          this.$message.error('系统错误：' + (error.message || '未知错误'))
        })
      }
      
      // 先尝试直接调用一次API看看是否能触发生成
      request('/api/Mindmap/getMindMapByInfo', { id, type })
        .then(() => {
          poll()
        })
        .catch(() => {
          poll()
        })
    },

    // 获取文档的唯一标识符
    getDocumentKey(item) {
      let docId = item.id
      if ([searchEmu.PAPER, searchEmu.THESIS].includes(this.activeName) && item.paper_id) {
        docId = item.paper_id
      }
      return `mindmap_saved_${this.activeName}_${docId}`
    },
    
    // 获取已保存的脑图ID
    getSavedMindId(item, idx) {
      // 首先检查当前状态中是否有
      if (this.list[idx].savedMindId) {
        return this.list[idx].savedMindId
      }
      
      // 然后检查localStorage中是否有
      const key = this.getDocumentKey(item)
      const savedMindId = localStorage.getItem(key)
      if (savedMindId) {
        // 如果localStorage中有，同步到当前状态
        this.list[idx].savedMindId = savedMindId
        return savedMindId
      }
      
      return null
    },
    
    // 设置已保存的脑图ID
    setSavedMindId(item, mindId, idx) {
      // 保存到当前状态
      this.list[idx].savedMindId = mindId
      
      // 保存到localStorage
      const key = this.getDocumentKey(item)
      localStorage.setItem(key, mindId)
    },
    
    // 清理已保存的脑图ID映射关系
    clearSavedMindId(item, idx) {
      // 清理当前状态
      if (this.list[idx]) {
        this.list[idx].savedMindId = null
      }
      
      // 清理localStorage
      const key = this.getDocumentKey(item)
      localStorage.removeItem(key)
    },
    
    // 转换原始数据格式为MindMap需要的格式
    convertToMindMapFormat(data) {
      const processNode = (item) => {
        if (!item || typeof item !== 'object') {
          return {
            data: {
              text: '无效节点'
            }
          }
        }
        
        let node = {
          data: {
            text: item.content || '未知内容'
          }
        };
        
        if (item.children && Array.isArray(item.children) && item.children.length > 0) {
          node.children = item.children.map(child => processNode(child));
        }
        
        return node;
      };
      
      return processNode(data);
    },
    
    // 将生成的脑图保存到脑图列表并跳转到编辑页面
    saveMindToListAndNavigate(item, mindData, idx) {
      const userInfo = JSON.parse(localStorage.getItem('userinfo'))
      const mindTitle = `${item.title}-AI脑图`
      
      // 创建新脑图
      axios.post('/ai/mind/add', {
        title: mindTitle,
        memberId: userInfo.userid
      }).then(res => {
        if(res.code === 200) {
          const mindId = res.data
          
          // 保存脑图数据
          const saveData = {
            id: mindId,
            detail: JSON.stringify(mindData)
          }
          
          axios.post('/ai/mind/save', saveData).then(saveRes => {
            if (saveRes.code === 200) {
              // 保存脑图ID映射关系
              this.setSavedMindId(item, mindId, idx)
              
              this.$message.success('脑图已保存，正在跳转到编辑页面...')
              
              // 跳转到编辑页面
              setTimeout(() => {
                window.open(`#/mind/${mindId}`, '_blank')
              }, 500)
            } else {
              this.$message.error('脑图数据保存失败：' + (saveRes.message || '未知错误'))
            }
          }).catch(saveError => {
            console.error('保存脑图数据失败:', saveError)
            this.$message.error('脑图数据保存失败：' + (saveError.message || '网络错误'))
          })
        } else {
          this.$message.error('创建脑图失败：' + (res.message || '未知错误'))
        }
      }).catch(error => {
        console.error('创建脑图失败:', error)
        this.$message.error('创建脑图失败：' + (error.message || '网络错误'))
      })
    },
    // 删除收藏文章
    async deleteCollectArticle (item, idx) {
      const params = {
        id: item.id
      }
      request('/api/wechatarticle/deleteArticle', params).then(() => {
        this.list.splice(idx, 1)
        this.$message({
          message: '删除成功',
          type: 'success',
          duration: 1000
        })
      }).catch((res) => {
        this.$message({
          message: res.message,
          type: 'error',
          duration: 1000
        })
      })
    },
    // 删除白板
    deleteDraft (item, idx) {
      request('/api/Draft/deleteDraft', {
        id: item.id
      }).then(() => {
        this.list.splice(idx, 1)
        this.$message({
          message: '删除成功',
          type: 'success',
          duration: 1000
        })
      })
    },
    deleteNote (item, idx) {
      request('/mobile/Bookwrite/delNote', {
        note_id: item.id
      }).then(() => {
        this.list.splice(idx, 1)
        this.$message({
          message: '删除成功',
          type: 'success',
          duration: 1000
        })
      })
    },
    deleteBookComment (item, idx) {
      request('/api/Comment/deleteComment', {
        comment_id: item.id
      }).then(() => {
        this.list.splice(idx, 1)
        this.$message({
          message: '删除成功',
          type: 'success',
          duration: 1000
        })
      })
    },
    deleteMindmap (item, idx) {
      axios.post('/ai/mind/delete', {
        mindId: item.id
      }).then((res) => {
        this.list.splice(idx, 1)
        this.$message({
          message: '删除成功',
          type: 'success',
          duration: 1000
        })
      }).catch((error) => {
        console.error('删除脑图失败:', error)
        this.$message({
          message: '删除失败',
          type: 'error',
          duration: 1000
        })
      })
    },
    deleteTimeline (item, idx) {
      request('/api/Timeline/deleteTimeline', {
        timeline_id: item.id
      }).then((res) => {
        this.list.splice(idx, 1)
        this.$message({
          message: '删除成功',
          type: 'success',
          duration: 1000
        })
        EventBus.$emit('timeline-deleted'); // 触发事件
      }).catch((error) => {
        console.error('删除时间轴失败:', error)
        this.$message({
          message: '删除失败',
          type: 'error',
          duration: 1000
        })
      })
    },
    deleteDoc (item, idx) {
      if ([searchEmu.PAPER, searchEmu.THESIS].includes(this.activeName)) {
        this.deletePaper(item, idx)
      } else if (this.activeName === searchEmu.ARTICLE) {
        this.deleteCollectArticle(item, idx)
      } else if (this.activeName === searchEmu.DRAFT) {
        this.deleteDraft(item, idx)
      } else if (this.activeName === searchEmu.NOTE) {
        this.deleteNote(item, idx)
      } else if (this.activeName === searchEmu.BOOK_COMMENT) {
        this.deleteCollectArticle(item, idx)
      } else if (this.activeName === searchEmu.MINDMAP) {
        this.deleteMindmap(item, idx)
      } else if (this.activeName === searchEmu.TIMELINE) {
        this.deleteTimeline(item, idx)
      }
    },

    getParerInfo (id) {
      request('/api/Paper/getPaperInfo', {
        paper_id: id
      }).then((result) => {
        const url = result.paper_url
        const title = result.paper_title
        const dotIndex = url.lastIndexOf('.')
        const extension = url.slice(dotIndex + 1)
        this.$emit('openUrl', {
          ...result,
          url: result.paper_url
        })
        if (extension === 'pdf') {
          this.$router.push({
            name: 'pdf',
            query: {
              paperId: id,
              title: title,
              url
            }
          })
        } else if (extension === 'epub') {
          this.$router.push({
            name: 'epub',
            query: {
              paperId: id,
              title: title,
              url
            }
          })
        } else if (extension === 'docx') {
          this.$router.push({
            name: 'docx',
            query: {
              paperId: id,
              title: title,
              url
            }
          })
        } else {
          // 检查是否是note页面
          const currentRoute = this.$route.name
          const currentPaperId = this.$route.query.paperId
          
          if (currentRoute === 'note' && currentPaperId) {
            // 先更新URL，再强制刷新整个页面
            const baseUrl = window.location.href.split('#')[0]
            const newUrl = `${baseUrl}#/editor/note?paperId=${id}&t=${Date.now()}`
            window.history.pushState(null, '', newUrl)
            window.location.reload()
          } else {
            // 否则使用普通路由跳转
            this.$router.push({
              name: 'note',
              query: {
                paperId: id,
                t: Date.now()
              }
            })
          }
        }
      })
    },
    toDetail (item) {
      
      if ([searchEmu.LOCAL, searchEmu.PAPER].includes(this.activeName)) {
        this.getParerInfo(item.id)
        return
      }
      const { id } = item
      if (this.activeName === searchEmu.DRAFT) {
        this.$router.push({
          name: 'draft',
          query: {
            id
          }
        })
      } else if (this.activeName === searchEmu.ARTICLE) {
        // 文章类型，统一跳转到article页面（包括好友分享文章）
        this.$router.push({
          name: 'article',
          query: {
            id: id
          }
        }).catch(err => {
          // 忽略重复导航错误
          if (err.name !== 'NavigationDuplicated') {
            console.error('路由跳转失败:', err)
          }
        })
      } else if (this.activeName === searchEmu.THESIS) {
        request('/api/Paper/getPaperInfo', {
          paper_id: id
        }).then((result) => {
          let url = ''
          if (result.paper_url.includes('https://oss.bookor.com.cn')) {
            url = result.paper_url
          } else {
            url = `https://oss.bookor.com.cn/${result.paper_url}`
          }
          this.$emit('openUrl', {
            ...result,
            url: result.paper_url
          })
          this.$router.push({
            name: 'pdfEmbed',
            query: {
              url,
              id,
              title: item.title
            }
          })
        })
      } else if (this.activeName === searchEmu.BOOK_COMMENT) {
        this.$router.push({
          name: 'bookComment',
          query: {
            id
          }
        })
      } else if (this.activeName === searchEmu.NOTE) {
        this.$router.push({
          name: 'bookNote',
          query: {
            id
          }
        })
      } else if (this.activeName === searchEmu.MINDMAP) {
        // 打开脑图
        window.open(`#/mind/${id}`, '_blank')
      } else if (this.activeName === searchEmu.TIMELINE) {
        // 打开时间轴详情
        this.$router.push({
          name: 'Timeline',
          query: {
            id: id
          }
        })
      }
    },
    getLocalList (id) {
      // 如果正在加载，直接返回，防止重复请求
      if (this.isLoading) {
        return
      }
      
      this.isLoading = true
      
      request('/api/Paper/getPaperList', {
        limit: this.size,
        page: this.page,
        paper_type: 'others'
      }).then((res) => {
        if (res.length < this.size) {
          this.isMore = false
        }
        const list = res.map((item) => {
          return {
            ...item,
            id: item.paper_id,
            title: item.paper_title
          }
        })
        if (this.page === 1) {
          this.list = list
        } else {
          this.list = [...this.list, ...list]
        }
        this.page += 1
      }).catch((error) => {
        console.error('获取本地文档列表失败:', error)
        this.isMore = false
      }).finally(() => {
        this.isLoading = false
      })
    },
    getList () {
      // 每次调用getList时，重置分页和列表状态，确保从第一页重新加载
      this.page = 1
      this.list = []
      this.isMore = true
      this.isLoading = false

      this.fetchDataForCurrentTab()
    },
    load () {
      if (this.isMore && !this.isLoading) {
        this.fetchDataForCurrentTab()
      }
    },
    fetchDataForCurrentTab() {
      const val = this.activeName
      if (val === searchEmu.PAPER) {
        this.getLocalList()
      } else if (val === searchEmu.MINDMAP) {
        this.getMindmapList()
      } else if (val === searchEmu.THESIS) {
        this.getPaperList()
      } else if (val === searchEmu.ARTICLE) {
        this.getArticle()
      } else if (val === searchEmu.BOOK_COMMENT) {
        this.getBookComment()
      } else if (val === searchEmu.NOTE) {
        this.getNoteList()
      } else if (val === searchEmu.DRAFT) {
        this.getDraftList()
      } else if (val === searchEmu.TIMELINE) {
        this.getTimelineList()
      }
    },
    getDraftList () {
      // 如果正在加载，直接返回，防止重复请求
      if (this.isLoading) {
        return
      }
      
      this.isLoading = true
      
      request('/api/Draft/draftList', {
        limit: this.size,
        page: this.page
      }).then((res) => {
        if (res.length < this.size) {
          this.isMore = false
        }
        const list = res
        if (this.page === 1) {
          this.list = list
        } else {
          this.list = [...this.list, ...list]
        }
        this.page += 1
      }).catch((error) => {
        console.error('获取白板列表失败:', error)
        this.isMore = false
      }).finally(() => {
        this.isLoading = false
      })
    },
    getMindmapList () {
      // 如果正在加载，直接返回，防止重复请求
      if (this.isLoading) {
        return
      }
      
      this.isLoading = true
      
      request('/api/Mindmap/mindmapList', {
        page: this.page,
        limit: this.size
      }).then(res => {
        // 处理接口返回的数据格式
        let data = []
        if (Array.isArray(res)) {
          // 如果直接返回数组
          data = res
        } else if (res && res.code === 200) {
          // 如果返回标准格式 {code: 200, result: [...]}
          data = res.result || []
        } else {
          console.error('脑图接口返回格式不正确:', res)
          this.isMore = false
          return
        }
        
        if (data.length < this.size) {
          this.isMore = false
        }
        
        const list = data.map((item) => {
          return {
            ...item,
            id: item.mind_map_id,
            title: item.content || item.title || '未命名脑图'
          }
        })
        
        if (this.page === 1) {
          this.list = list
        } else {
          this.list = [...this.list, ...list]
        }
        this.page += 1
      }).catch((error) => {
        console.error('获取脑图列表失败:', error)
        this.isMore = false
      }).finally(() => {
        this.isLoading = false
      })
    },
    getTimelineList () {
      // 如果正在加载，直接返回，防止重复请求
      if (this.isLoading) {
        return
      }
      
      this.isLoading = true
      
      request('/api/Timeline/timelineList', {
        page: this.page,
        limit: this.size
      }).then((res) => {
        // 处理接口返回的数据格式
        let data = []
        if (Array.isArray(res)) {
          // 如果直接返回数组
          data = res
        } else if (res && res.code === 200) {
          // 如果返回标准格式 {code: 200, result: [...]}
          data = res.result || []
        } else {
          console.error('时间轴接口返回格式不正确:', res)
          this.isMore = false
          return
        }
        
        if (data.length < this.size) {
          this.isMore = false
        }
        
        const list = data.map((item) => {
          return {
            ...item,
            id: item.timeline_id,
            title: item.title
          }
        })
        
        if (this.page === 1) {
          this.list = list
        } else {
          this.list = [...this.list, ...list]
        }
        this.page += 1
      }).catch((error) => {
        console.error('获取时间轴列表失败:', error)
        this.isMore = false
      }).finally(() => {
        this.isLoading = false
      })
    },
    getNoteList () {
      // 如果正在加载，直接返回，防止重复请求
      if (this.isLoading) {
        return
      }
      
      this.isLoading = true
      
      request('/mobile/member/reviewsList', {
        page: this.page,
        limit: this.size,
        search_status: 'off',
        data_type: 'self',
        article_type: 'note',
        member_type: 'self'
      }).then((res) => {
        if (res.list.length < this.size) {
          this.isMore = false
        }
        const list = res.list.map((item) => {
          return {
            ...item,
            id: item.article_id
          }
        })
        if (this.page === 1) {
          this.list = list
        } else {
          this.list = [...this.list, ...list]
        }
        this.page += 1
      }).catch((error) => {
        console.error('获取笔记列表失败:', error)
        this.isMore = false
      }).finally(() => {
        this.isLoading = false
      })
    },
    getBookComment () {
      // 如果正在加载，直接返回，防止重复请求
      if (this.isLoading) {
        return
      }
      
      this.isLoading = true
      
      request('mobile/member/reviewsList', {
        article_type: 'comment',
        data_type: 'self',
        limit: this.size,
        member_type: 'self',
        page: this.page,
        search_status: 'off'
      }).then((res) => {
        if (res.list.length < this.size) {
          this.isMore = false
        }
        const list = res.list.map((item) => {
          return {
            ...item,
            id: item.article_id
          }
        })
        if (this.page === 1) {
          this.list = list
        } else {
          this.list = [...this.list, ...list]
        }
        this.page += 1
      }).catch((error) => {
        console.error('获取书评列表失败:', error)
        this.isMore = false
      }).finally(() => {
        this.isLoading = false
      })
    },
    async getArticle() {
      // 防止重复请求
      if (this.isLoading) {
        return;
      }
      
      this.isLoading = true;
      
      try {
        // 第一页：同时加载好友分享文章和个人文章
        if (this.page === 1) {
          const [firstPageArticles, shareArticles] = await Promise.all([
            request('api/wechatarticle/articleList', { 
              limit: this.size, 
              page: this.page 
            }),
            request('/api/wechatarticle/getSumUpShareList', { 
              page: 1, 
              limit: 100, 
              is_self: "friend" 
            }, 'post').then(res => {
              if (res && res.list && res.list.length > 0) {
                return res.list.map(item => {
                  let sum_up = item.sum_up || '';
                  sum_up = sum_up.replaceAll("/[\r\n]/g", " ")
                    .replace(/&nbsp;/g, " ")
                    .replace("hasSetZeroLevel:true", "")
                    .replace(/\[p\d+\]/g, '');
                  return { 
                    ...item, 
                    isShared: true, 
                    share_id: item.id, // 保存分享记录ID，用于调用getFriendArticleById接口
                    author: item.nickname || '匿名好友', 
                    share_time: new Date(item.add_time * 1000).toLocaleDateString(), 
                    id: `share-${item.id}`, // 使用分享记录ID而不是article_id
                    title: item.title || '未命名文章',
                    url: item.url || '' 
                  };
                });
              }
              return [];
            }).catch(err => {
              console.error('获取好友分享文章失败:', err);
              return [];
            })
          ]);
          
          // 合并好友分享文章和个人文章
          this.list = [...shareArticles, ...firstPageArticles];
          
          // 判断是否还有更多数据
          if (firstPageArticles.length < this.size) {
            this.isMore = false;
          }
          
          this.page += 1;
        } else {
          // 后续页：只加载个人文章
          const articles = await request('api/wechatarticle/articleList', { 
            limit: this.size, 
            page: this.page 
          });
          
          if (articles.length < this.size) {
            this.isMore = false;
          }
          
          const list = articles.map((item) => {
            return {
              ...item,
              id: item.article_id || item.id,
              title: item.title || '未命名文章'
            };
          });
          
          this.list = [...this.list, ...list];
          this.page += 1;
        }
      } catch (error) {
        console.error('获取文章列表失败:', error);
        this.isMore = false;
        this.$message.error('获取文章列表失败，请重试');
      } finally {
        this.isLoading = false;
      }
    },
    getPaperList () {
      // 如果正在加载，直接返回，防止重复请求
      if (this.isLoading) {
        return
      }
      
      this.isLoading = true
      
      request('/api/Paper/getPaperList', {
        limit: this.size,
        page: this.page,
        paper_type: 'paper'
      }).then((res) => {
        if (res.length < this.size) {
          this.isMore = false
        }
        const list = res.map((item) => {
          return {
            ...item,
            id: item.paper_id,
            title: item.paper_title
          }
        })
        if (this.page === 1) {
          this.list = list
        } else {
          this.list = [...this.list, ...list]
        }
        this.page += 1
      }).catch((error) => {
        console.error('获取论文列表失败:', error)
        this.isMore = false
      }).finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.list-con{
  background-color: #fff;
  border-radius: 6px;
  .item{
    white-space: nowrap;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis; /* 显示省略号 */
    height: 50px;
    padding-left: 10px;
    line-height: 50px;
    border-bottom: 1px solid #EBEEF5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &.shared-item {
      // &.shared-item不再有特殊背景
      .wechat-icon {
        filter: none; // 恢复微信图标原来的颜色
      }
    }
  }
  .right-func{
    display: flex;
    align-items: center;
    gap: 6px;
    .mind-btn{
      cursor: pointer;
      width: 14px;
      height: auto;
    }
  }

}
.empty{
  color: #999;
  text-align: center;
  padding: 40px 0;
}
.item-title{
  white-space: nowrap;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis; /* 显示省略号 */
  width: 350px;
}
.icon-pdf{
  width: 20px;
  height: 20px;
  position: relative;
  top: 5px;
  margin-right: 4px;
}
.icon-mindmap{
  width: 20px;
  height: 20px;
  font-size: 18px;
  color: #409EFF;
  position: relative;
  top: 2px;
  margin-right: 4px;
}

</style>
